import { render } from "./pagerList.vue?vue&type=template&id=4ff5eca8"
import script from "./pagerList.vue?vue&type=script&lang=js"
export * from "./pagerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__